import { tx } from "@/i18n/tx";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, formatError } from "@/lib/api";
import { toast } from "sonner";
import { ArrowLeft, MailCheck } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      toast.error(formatError(err.response?.data?.detail));
    } finally { setBusy(false); }
  };

  return (
    <div className="anima-backdrop min-h-screen w-full flex justify-center">
      <div className="w-full max-w-md px-7 py-10 flex flex-col min-h-screen">
        <button onClick={() => navigate("/auth?mode=login")} className="self-start text-anima-muted mb-8 flex items-center gap-1 text-sm">
          <ArrowLeft size={16} />{tx("Torna all'accesso")}</button>
        {!sent ? (
          <>
            <h1 className="font-serif text-4xl text-anima-ink mb-2">{tx("Password dimenticata")}</h1>
            <p className="text-anima-muted mb-8">{tx("Inserisci la tua email: se e associata a un account, ti invieremo un collegamento sicuro per reimpostare la password.")}</p>
            <form onSubmit={submit} className="space-y-4">
              <input
                data-testid="forgot-email-input" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required
                className="w-full rounded-2xl bg-white/60 border border-anima-ink/10 px-4 py-3.5 outline-none focus:border-anima-sage"
                placeholder={tx("nome@email.it")}
              />
              <button data-testid="forgot-submit-btn" disabled={busy} className="w-full rounded-full bg-anima-sagedeep text-anima-ivory py-4 font-medium disabled:opacity-60">
                {busy ? "Invio..." : tx("Invia il collegamento")}
              </button>
            </form>
          </>
        ) : (
          <div className="flex-1 flex flex-col items-center justify-center text-center" data-testid="forgot-sent">
            <MailCheck size={48} className="text-anima-sagedeep mb-4" />
            <h1 className="font-serif text-3xl text-anima-ink mb-3">{tx("Controlla la tua email")}</h1>
            <p className="text-anima-muted mb-8">{tx("Se l'indirizzo e associato a un account, riceverai a breve un'email con le istruzioni per reimpostare la password.")}</p>
            <button onClick={() => navigate("/auth?mode=login")} className="rounded-full border border-anima-ink/15 text-anima-ink px-6 py-3">{tx("Torna all'accesso")}</button>
          </div>
        )}
      </div>
    </div>
  );
}
